@if (!hidden()) {
  @if (_isDesktop()) {
    <a class="tw-cursor-pointer" (click)="toggle()">
      <div class="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6">
        <div class="menu-toggle-button__icon tw-flex tw-flex-col" [class.is-open]="isOpen()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </a>
  } @else {
    <button
      mat-icon-button
      name="menu"
      aria-label="menu"
      class="tw-flex menu-toggle-button__menu-icon"
      (click)="toggle()"
    >
      <mat-icon class="material-symbols-rounded">menu</mat-icon>
    </button>
  }
} @else {
  <div class="tw-w-6 tw-h-6"></div>
}
